export default {
    'Internal media storage is empty.': 'La mémoire interne du média est vide.',
}